import React from 'react';

const CommandIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg {...props} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.6666 9.33398H9.33325V18.6673H18.6666V9.33398Z" fill="#30A5C1"/>
<path d="M2.33325 22.166C2.33325 24.091 3.90825 25.666 5.83325 25.666C7.75825 25.666 9.33325 24.091 9.33325 22.166V18.666H5.83325C3.90825 18.666 2.33325 20.241 2.33325 22.166Z" fill="#30A5C1"/>
<path d="M5.83325 2.33398C3.90825 2.33398 2.33325 3.90898 2.33325 5.83398C2.33325 7.75898 3.90825 9.33398 5.83325 9.33398H9.33325V5.83398C9.33325 3.90898 7.75825 2.33398 5.83325 2.33398Z" fill="#30A5C1"/>
<path d="M25.6667 5.83398C25.6667 3.90898 24.0917 2.33398 22.1667 2.33398C20.2417 2.33398 18.6667 3.90898 18.6667 5.83398V9.33398H22.1667C24.0917 9.33398 25.6667 7.75898 25.6667 5.83398Z" fill="#30A5C1"/>
<path d="M22.1667 18.666H18.6667V22.166C18.6667 24.091 20.2417 25.666 22.1667 25.666C24.0917 25.666 25.6667 24.091 25.6667 22.166C25.6667 20.241 24.0917 18.666 22.1667 18.666Z" fill="#30A5C1"/>
</svg>

);

export default CommandIcon;
